/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleLeftIcon16Regular = forwardRef('ArrowFigureACircleLeftIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M11.75 8a.75.75 0 0 0-.75-.75H6.572L7.98 6.076a.75.75 0 1 0-.96-1.152L4.942 6.656c-.84.7-.84 1.989 0 2.688l2.078 1.732a.75.75 0 0 0 .96-1.152L6.572 8.75H11a.75.75 0 0 0 .75-.75Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 8A7 7 0 1 0 1 8a7 7 0 0 0 14 0ZM8 2.5a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Z" })));
});
